window['BABY_STYLE_BG'] = '#fff';
